import { useMemo } from 'react';
import { EUserRole, TUserRole } from 'shared/types/card.interface';

export const useRole = (
  initiatorId: number | undefined,
  opponentId: number | undefined,
  currentUserId: number | undefined,
): TUserRole => {
  const currentRole = useMemo(() => {
    if (currentUserId && initiatorId === currentUserId) return EUserRole.Initiator;
    if (currentUserId && opponentId === currentUserId) return EUserRole.Opponent;
    return EUserRole.RegularUser;
  }, [currentUserId, initiatorId, opponentId]);
  return currentRole;
};
